/*global _gaq*/
import React from "react";

import { servicios } from "../properties";
import { goTo } from "../tools";
import gnpServicios from "../gnp-servicios/gnp-servicios.css";
import Paginador from "./paginador.cmpt";
import { connect } from "react-redux";

const mapState = (state) => {
	return {
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		addEvento: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class Ligas extends React.Component {
	state = {
		/*ligas: [
			{
				"descripcion": "Vida Inversión, Elige y Consolida Total",
				"url": "https://www.gnp.com.mx/wps/portal/portalesgnp/vida-inversion"
			},
			{
				"descripcion": "Apoyos para Trámites y Siniestros",
				"tag": [],
				"child": [{
					"descripcion": "¿Qué hacer en caso de siniestro?",
					"tag": [],
					"url": "https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/contacto/masinfo/servicios-relacionados/hacer-caso-siniestros/caso-siniestro-auto/!ut/p/b1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOLN_L1D3SwdAwLdzS0MDRxNPEM8www8jQIsDIEKInErsDQ3pUx_kCFF-kPdjYnTb4ADOBoQ0u-lH5Wek58EDCo_j_zcVP2C3NDQ0IhKRwDZoTLj/dl4/d5/L2dBISEvZ0FBIS9nQSEh/"
				},{
					"descripcion": "Directorios",
					"tag": ["_trackEvent", "asistenciaycontacto", "directorio", "medicos",2],
					"url": "https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/contacto/masinfo/servicios-relacionados/directorios/medicos/!ut/p/b1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOLN_L1D3SwdAwLdzS0MDRxNPEM8www8jSzDDIAKIvEoCDKkSH-ouzFx-g1wAEcDQvq99KPSc_KTgF7188jPTdUvyA0Njah0VAQAw9cq1g!!/dl4/d5/L2dBISEvZ0FBIS9nQSEh/"
				},{
					"descripcion": "Formatos",
					"tag": ["_trackEvent", "sectorpublico", "productosinstitucionales", "accidentespersonales",2],
					"url": "https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/contacto/masinfo/servicios-relacionados/formatos/formatos-masinfo/!ut/p/b1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOLN_L1D3SwdAwLdzS0MDRxNPEM8www8jQKczYEKInErsDQ3pUx_kCFF-kPdjYnTb4ADOBoQ0u-lH5Wek58EDCo_j_zcVP2C3NDQ0IhKRwAFDfNT/dl4/d5/L2dBISEvZ0FBIS9nQSEh/"
				},{
					"descripcion": "Proveedores médicos en el extranjero",
					"tag": ["_trackEvent", "omhc", "gnpproviders", "gnpproviders",2],
					"url": "https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/contacto/masinfo/servicios-relacionados/proveedores/mas-info/extranjero/medicos-extranjero/!ut/p/b1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOLN_L1D3SwdAwLdzS0MDRxNPEM8www8jQI8TYAKInErsDQ3pUx_kCFF-kPdjYnTb4ADOBoQ0u-lH5Wek58EDCo_j_zcVP2C3NDQ0IhKRwATS8z3/dl4/d5/L2dBISEvZ0FBIS9nQSEh/"
				},{
					"descripcion": "Localiza el centro de reparación de tu auto ",
					"tag": [],
					"url": "https://serviciosmoviles.gnp.com.mx/Segmentacion/centros.html#esPersiana313"
				},{
					"descripcion": "¿Sabes si tu auto es robado?",
					"tag": ["_trackEvent", "asistenciaycontacto", "prevencion", "prevencion",2],
					"url": "http://www.amis.org.mx/InformaWeb/ReporteRobo.html"
				}]
			},
			{
				"descripcion": "Tips para contraseñas seguras",
				"tag": [],
				"url": "https://www.gnp.com.mx/wps/portal/portalesgnp/tips-csegura/!ut/p/b1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOLN_L1D3SwdAwINPExcDRwtfQ2MjEIsjUwMTIAKIoEKDHAARwNC-r30ozKTcvXKk3P1DPSMLY1NTc1NzY1MDI0NjY3N9P088nNT9QtyIyodHRUVAZpP7N4!/dl4/d5/L2dBISEvZ0FBIS9nQSEh/"
			},
			{
				"descripcion": "GNP Cuida tu Salud",
				"tag": [],
				"url": "http://gnpcuidatusalud.com/"
			},
			{
				"descripcion": "Blog Viviendo GNP",
				"tag": ["_trackEvent", "rvgnp", "rvcrm", "rvcrm",2],
				"url": "http://gnpviviresincreible.com.mx/",
			},
			{
				"descripcion": "Condiciones Generales",
				"tag": ["_trackEvent", "soycliente", "login", "CondicionesGenerales",2],
				"url": "https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/contacto/masinfo/servicios-relacionados/condiciones/condiciones-masinfo/!ut/p/b1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOLN_L1D3SwdAwItQj2cDRzNXMKCjdyMDNwtzYAKIpEVuJtbGBo4mniGeIYZeBpZmptSpj_IkCL9oe7GxOk3wAEcDQjp99KPSs_JTwIGlZ9Hfm6qfkFuaGhoRKUjAJzR04E!/dl4/d5/L2dBISEvZ0FBIS9nQSEh/"
			},
			{
				"descripcion": "Unidad Especializada de Atención a Usuarios",
				"tag": ["_trackEvent", "soycliente", "login", "UNE",2],
				"url": "https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/contacto/masinfo/unidad/une/une-masinfo/!ut/p/b1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOLN_L1D3SwdAwL9vTwNDRzNzIItA0IDjII9TYAKIpEVuJtbABWYeIZ4hhl4GlkGGVKkP9TdmDj9BjiAowEh_V76Uek5-UlAr_p55Oem6hfkhoZGVDoqAgBSAB9k/dl4/d5/L2dBISEvZ0FBIS9nQSEh/"
			},
			{
				"descripcion": "GNP Smart Drive Naranja",
				"tag": [],
				"url": "https://smartdrive.gnp.com.mx/smartdrive/"
			},
			{
				"descripcion": "GNP Smart Drive Azul",
				"tag": [],
				"url": "https://gnpsmartdrive.octousa.com/login"
			},
			{
				"descripcion": "Previene GNP (Gestiona)",
				"tag": [],
				"url": "https://previene.gnp.com.mx/"
			},
			{
				"descripcion": "Asistencia legal y fianza de autos",
				"tag": [],
				"url": "http://asistencialegal.gnp.com.mx/gnsin/gnsin071.nsf/login?openform"
			},
			{
				"descripcion": "Solicita tu RC en E.U.A.",
				"tag": ["_trackEvent", "asistenciaycontacto", "rcestadosunidos", "rcestadosunidos",2],
				"url": "https://www.acemexico.net/rcGNP.htm"
			}
		],*/
		ligas: [
			{
				"descripcion": "Vida Inversión, Elige y Consolida Total",
				"target": "_self",
				"url": "/vida-inversion"
			},
			{
				"descripcion": "Apoyos para Trámites y Siniestros",
				"tag": [],
				"child": [{
					"descripcion": "¿Qué hacer en caso de siniestro?",
					"target": "_self",
					"tag": [],
					//"url": "/post-venta/contacto/masinfo/servicios-relacionados/hacer-caso-siniestros/caso-siniestro-auto"
					"url": "/asistencia-en-siniestro-de-auto"
				}, {
					"descripcion": "Directorios",
					"target": "_self",
					"tag": ["_trackEvent", "asistenciaycontacto", "directorio", "medicos", 2],
					//"url": "/post-venta/contacto/masinfo/servicios-relacionados/directorios/medicos#!/gnp/directorios"
					"url": "/directorio-proveedores-medicos"
				}, {
					"descripcion": "Formatos",
					"target": "_self",
					"tag": ["_trackEvent", "sectorpublico", "productosinstitucionales", "accidentespersonales", 2],
					//"url": "/post-venta/contacto/masinfo/servicios-relacionados/formatos/formatos-masinfo#!/gnp/servicios-formatos"
					"url": "/formatos-para-tramites-soy-cliente-gnp"
				}, {
					"descripcion": "Solicita tu RC en EUA",
					"target": "_self",
					"tag": ["_trackEvent", "sectorpublico", "productosinstitucionales", "ev_acceso_soycliente_rcusa", 2],
					"url": "https://rceua.gnp.com.mx/"
				}
					, {
					"descripcion": "Asistencia Internacional ",
					"target": "_self",
					"tag": ["_trackEvent", "omhc", "gnpproviders", "gnpproviders", 2],
					//"url": "/post-venta/contacto/masinfo/servicios-relacionados/proveedores/mas-info/extranjero/medicos-extranjero"
					"url": servicios.app === "https://www.gnp.com.mx/soy-cliente" ? "/asistencia-internacional-gnp" : "/asistencia-internacional"
				}, {
					"descripcion": "Localiza el centro de reparación de tu auto",
					"target": "_blank",
					"tag": [],
					"url": servicios.ulrtalleres
				}, {
					"descripcion": "¿Sabes si tu auto es robado?",
					"target": "_blank",
					"tag": ["_trackEvent", "asistenciaycontacto", "prevencion", "prevencion", 2],
					"url": "http://www.amis.org.mx/InformaWeb/ReporteRobo.html"
				}]
			},
			{
				"descripcion": "GNP Cuida tu Salud",
				"target": "_blank",
				"tag": [],
				"url": "http://gnpcuidatusalud.com/"
			},
			/*{
				"descripcion": "Blog Viviendo GNP",
				"target": "_blank",
				"tag": ["_trackEvent", "rvgnp", "rvcrm", "rvcrm",2],
				"url": "http://gnpviviresincreible.com.mx/",
			},*/
			{
				"descripcion": "Condiciones Generales",
				"target": "_self",
				"tag": ["_trackEvent", "soycliente", "login", "CondicionesGenerales", 2],
				//"url": "/post-venta/contacto/masinfo/servicios-relacionados/condiciones/condiciones-masinfo#!/gnp/servicios-condiciones-generales"
				"url": "/condiciones-generales-soy-cliente-gnp"
			},
			{
				"descripcion": "Unidad Especializada de Atención a Usuarios",
				"target": "_self",
				"tag": ["_trackEvent", "soycliente", "login", "UNE", 2],
				//"url": "/post-venta/contacto/masinfo/unidad/une/une-masinfo"
				"url": "/unidad-de-atencion-especializada-usuarios"
			},
			/*{
				"descripcion": "GNP Smart Drive Naranja",
				"target": "_blank",
				"tag": [],
				"url": "https://smartdrive.gnp.com.mx/smartdrive/"
			},
			{
				"descripcion": "GNP Smart Drive Azul",
				"target": "_blank",
				"tag": [],
				"url": "https://gnpsmartdrive.octousa.com/login"
			},*/
			{
				"descripcion": "Previniendo con GNP (Gestiona)",
				"target": "_blank",
				"tag": [],
				"url": "https://previene.gnp.com.mx/"
			},
			// {
			// 	"descripcion": "Reporte de Siniestro Casa Habitación ",
			// 	"target": "_blank",
			// 	"tag": [],
			// 	"url": "/reporte-de-siniestros-casa-habitacion"
			// },
			{
				"descripcion": "Inspección Vehicular",
				"target": "_self",
				"tag": ["_trackEvent", "soycliente", "login", "InspeccionVehicular", 2],
				"url": "/inspeccionvehicular"
			}/*,
			{
				"descripcion": "Asistencia legal y fianza de autos",
				"target": "_blank",
				"tag": [],
				"url": "http://asistencialegal.gnp.com.mx/gnsin/gnsin071.nsf/login?openform"
			},
			{
				"descripcion": "Solicita tu RC en E.U.A.",
				"target": "_blank",
				"tag": ["_trackEvent", "asistenciaycontacto", "rcestadosunidos", "rcestadosunidos",2],
				"url": "https://www.acemexico.net/rcGNP.htm"
			}*/
		],
		paginaLigas: []
	}

	onCambiaPagina = (paginaElementos) => {
		this.setState({ paginaLigas: paginaElementos });
	}

	vertodos = () => {
		window.location.replace(servicios.utilerias.videos);
		this.props.tagManager({ "type": "EVENT_LOGIN_VER-TODOS-VIDEOS", "dispositivo": this.props.dispositivo });
	}

	goVideoPromo = () => {
		window.location.replace('https://www.gnp.com.mx/conoce-nuestro-portal-soy-cliente');
		this.props.tagManager({ "type": "EVENT_LOGIN_VIDEO-PRINCIPAL", "dispositivo": this.props.dispositivo });
	}

	pagina = (oItem) => {
		this.analytics(oItem.tag);
		this.props.addEvento(oItem.descripcion);
		const downloadUrl = URL.createObjectURL(fileBlob);
		var createA = document.createElement('a');
		createA.setAttribute('target', oItem.target)
		createA.setAttribute('href', downloadUrl);
		createA.click();
	}

	analytics = (aTag) => {
		if (aTag && aTag.length > 0) {
			try {
				_gaq.push(aTag);
			} catch (e) {
				alert("Error al taggear.");
			}
		}
	}

	render() {
		var mostrarBanner;
		const url = window.location.hash;

		if (url.includes("#!/gnp/registro-seguridad/") || url.includes("#!/registro-familiar/")) {
			mostrarBanner = false;
		} else {
			mostrarBanner = true;
		}

		return mostrarBanner !== false && <div className="contenedorLigas layout-md-row">
			<div>
				<h7 className="tituloLigas">Conoce algunos de los servicios que GNP tiene en línea para ti:</h7>
				<ul className="listaLigas" style={{ "display": "none" }}>
					{this.state.paginaLigas.map((liga, i) =>
						<li key={i} className="lista">
							<a onClick={this.pagina.bind(this, liga)}>{liga.descripcion}</a>
						</li>
					)}
				</ul>

				<div className="gnp-servicios">
					<div className="btn-group-vertical" role="group" aria-label="...">
						{this.state.paginaLigas.map((item, i) => {
							if (item.child) {
								return (
									<div key={i} className="btn-group" role="group">
										<button onClick={this.props.addEvento.bind(this, item.descripcion)} type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
											{item.descripcion}
											<span className="caret"></span>
										</button>
										<ul className="dropdown-menu">
											{item.child.map((child, a) =>
												<li key={a}><a onClick={this.pagina.bind(this, child)}>{child.descripcion}</a></li>
											)}
										</ul>
									</div>
								);
							} else {
								return <button key={i} type="button" onClick={this.pagina.bind(this, item)} className="btn btn-default">{item.descripcion}</button>;
							}
						})}
					</div>
				</div>

				<div className="paginador">
					<Paginador elementos={this.state.ligas} onCambiaPagina={this.onCambiaPagina} />
				</div>
			</div>
			<div className="flex hide-md hide-gt-md">
				<div>
					<h6 className="titulovideo">Conoce nuestro portal:</h6>
				</div>
				<p className="textovideo">Aquí podrás ver video explicativo y conocer los grandes beneficios que tenemos para ti.</p>
				<div>
					<img className="videop" style={{ "cursor": "pointer" }} onClick={this.goVideoPromo} src={require("../img/video.png")} />
				</div>
				<div>
					<span className="videobullet">&bull; </span><a className="ligavideos" onClick={this.vertodos}>Ver todos los videos</a>
				</div>
			</div>
			<div className="hide-xs hide-sm hide-gt-md" style={{ "width": 1, "height": 314, "backgroundColor": "rgb(216,216,216)", "margin": "0px 30px" }}>
				&nbsp;
			</div>
			<div className="flex layout-column hide-xs hide-sm hide-gt-md" style={{ "width": 465 }}>
				<div>
					<h6 className="titulovideo">Conoce nuestro portal:</h6>
				</div>
				<div className="flex layout-row">
					<div>
						<img className="videop" style={{ "cursor": "pointer" }} onClick={this.goVideoPromo} src={require("../img/video.png")} />
					</div>
					<div className="descripcionvideo">
						<p className="textovideo">Aquí podrás ver video explicativo y conocer los grandes beneficios que tenemos para ti.</p>
						<span className="videobullet">&bull; </span><a className="ligavideos" onClick={this.vertodos}>Ver todos los videos</a>
					</div>
				</div>
			</div>
			<div className="flex layout-row hide-xs hide-sm hide-md">
				<div>
					<img className="videop" style={{ "cursor": "pointer" }} onClick={this.goVideoPromo} src={require("../img/videodesk.png")} />
				</div>
				<div className="descripcionvideo">
					<h6 className="titulovideo">Conoce nuestro portal:</h6>
					<p className="textovideo">Aquí podrás ver video explicativo y conocer los grandes beneficios que tenemos para ti.</p>
					<span className="videobullet">&bull; </span><a className="ligavideos" onClick={this.vertodos}>Ver todos los videos</a>
				</div>
			</div>
		</div>;
	}
}
export default connect(mapState, mapDispatch)(Ligas);



// WEBPACK FOOTER //
// ./src/home/ligas.cmpt.js